export type TCalculateTotalHPParams = {
  a3HP: number
  a4HP: number
}
export const calculateTotalHP = (hpFormats: TCalculateTotalHPParams) => {
  return hpFormats.a3HP + hpFormats.a4HP
}
